var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo, useEffect, useLayoutEffect, useRef } from "react";
export var focusInput = function (inputRef, focus, autoFocus, prevFocus) {
    if (inputRef.current) {
        if (focus && autoFocus) {
            inputRef.current.focus();
        }
        if (focus && autoFocus && focus !== prevFocus) {
            inputRef.current.select();
        }
    }
};
export var SingleOTPInputComponent = function (props) {
    var focus = props.focus, autoFocus = props.autoFocus, rest = __rest(props, ["focus", "autoFocus"]);
    function usePrevious(value) {
        var ref = useRef();
        useEffect(function () {
            ref.current = value;
        }, [value]);
        return ref.current;
    }
    var inputRef = useRef(null);
    var prevFocus = usePrevious(!!focus);
    useLayoutEffect(function () { return focusInput(inputRef, focus, autoFocus, prevFocus); }, [
        autoFocus,
        focus,
        prevFocus,
    ]);
    return React.createElement("input", __assign({ ref: inputRef }, rest));
};
var SingleOTPInput = memo(SingleOTPInputComponent);
export default SingleOTPInput;
